import ResultStats from './ResultStats';

export default ResultStats;
